import { Icon } from '@billy/design-system'
import { ReactElement } from 'react'

import { AvatarImage } from '../AvatarImage'
import { AvatarPlaceholder } from './elements/AvatarPlaceholder'
import * as Styled from './styles'

interface OrganizationAvatarProps {
  organizationId?: string
  organizationName?: string
  src?: string | null
}

export const OrganizationAvatar = ({
  organizationId,
  organizationName,
  src,
}: OrganizationAvatarProps): ReactElement => {
  if (!organizationName || !organizationId) {
    return <Icon icon="briefcaseBusiness" />
  }

  return (
    <Styled.OrganizationAvatarWrapper>
      {src ? (
        <AvatarImage src={src} alt={`avatar-${organizationName}`} />
      ) : (
        <AvatarPlaceholder id={organizationId} name={organizationName} />
      )}
    </Styled.OrganizationAvatarWrapper>
  )
}
